import { render, staticRenderFns } from "./DHZ.vue?vue&type=template&id=21438174&scoped=true"
import script from "./DHZ.vue?vue&type=script&lang=js"
export * from "./DHZ.vue?vue&type=script&lang=js"
import style0 from "./DHZ.vue?vue&type=style&index=0&id=21438174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21438174",
  null
  
)

export default component.exports